import pbfe from "./pbfe.js";
import { _, t } from "./i18n.js";
import createNavbar from "./navbar.js";
import { LANG_URL_MAP, getLang, navigate } from "./index.js";
import { posts } from "./blog-posts.js";

var container, box;

function init(_container) {
    container = _container;
    
    // Clear previous content if exists
    if (box && box.element) {
        box.element.innerHTML = "";
    } else {
        box = new pbfe.Flexbox("column");
        box.element.id = "blogScreen";
        box.element.className = "main-screen";
    }
    
    // Navbar
    var navbar = createNavbar();
    box.appendChild(navbar);

    // Content Container
    var contentBox = new pbfe.Flexbox("column");
    contentBox.element.id = "blogContentBox";
    contentBox.alignItems = "center";
    
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    
    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    t(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", () => {
        var lang = getLang();
        var prefix = LANG_URL_MAP[lang];
        var path = prefix ? "/" + prefix : "/";
        
        navigate(path);
    });
    breadcrumb.appendChild(homeLink);
    
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    t(current, "Blog");
    breadcrumb.appendChild(current);
    
    contentBox.appendChild({ element: breadcrumbContainer });
    
    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    t(title, "Blog");
    contentBox.appendChild({ element: title });

    // Blog List Container
    var listContainer = document.createElement("div");
    listContainer.className = "blog-container";

    posts.forEach((post) => {
        var wrapper = document.createElement("div");
        wrapper.className = "blog-card";
        
        // Thumbnail (Left)
        var thumbnailContainer = document.createElement("div");
        thumbnailContainer.className = "blog-thumbnail-container";
        var img = document.createElement("img");
        img.src = post.image;
        img.className = "blog-thumbnail";
        thumbnailContainer.appendChild(img);
        wrapper.appendChild(thumbnailContainer);
        
        // Content (Right)
        var content = document.createElement("div");
        content.className = "blog-content";
        
        // Meta Top (Category badge + Date/Time)
        var metaTop = document.createElement("div");
        metaTop.className = "blog-meta-top";
        
        var category = document.createElement("span");
        category.className = "blog-category";
        category.innerText = post.category;
        category.style.backgroundColor = post.color;
        metaTop.appendChild(category);
        
        var metaInfo = document.createElement("span");
        metaInfo.className = "blog-meta-info";
        metaInfo.innerHTML = `📅 ${post.date} &nbsp; ⏱ ${post.readTime} <span class="min-read-text"></span>`;
        t(metaInfo.querySelector(".min-read-text"), "min read");
        metaTop.appendChild(metaInfo);
        
        content.appendChild(metaTop);
        
        // Title
        var blogTitle = document.createElement("h2");
        blogTitle.className = "blog-title clickable";
        blogTitle.innerText = post.title;
        blogTitle.addEventListener("click", () => {
            var lang = getLang();
            var prefix = LANG_URL_MAP[lang];
            var path = prefix ? "/" + prefix + "/blog/" + post.slug : "/blog/" + post.slug;
            
            navigate(path);
        });
        content.appendChild(blogTitle);
        
        // Summary
        var summary = document.createElement("p");
        summary.className = "blog-summary";
        summary.innerText = post.summary;
        content.appendChild(summary);
        
        // Tags
        var tagsContainer = document.createElement("div");
        tagsContainer.className = "blog-tags";
        post.tags.forEach(tag => {
            var tagSpan = document.createElement("span");
            tagSpan.className = "blog-tag";
            tagSpan.innerText = tag;
            tagsContainer.appendChild(tagSpan);
        });
        content.appendChild(tagsContainer);
        
        // Read Button
        var readBtn = document.createElement("button");
        readBtn.className = "blog-read-btn";
        readBtn.innerHTML = `<span class="blog-read-text"></span> ➔`;
        t(readBtn.querySelector(".blog-read-text"), "Read Article");
        readBtn.addEventListener("click", () => {
            var lang = getLang();
            var prefix = LANG_URL_MAP[lang];
            var path = prefix ? "/" + prefix + "/blog/" + post.slug : "/blog/" + post.slug;
            
            navigate(path);
        });
        content.appendChild(readBtn);

        wrapper.appendChild(content);
        listContainer.appendChild(wrapper);
    });

    contentBox.appendChild({ element: listContainer });
    box.appendChild(contentBox);
}

function show() {
    container.appendChild(box);
    setTimeout(() => box.element.classList.add("show"), 0);
}

function hide() {
    if (!box) return;
    box.element.classList.remove("show");
    if (container && container.contains(box)) {
        container.removeChild(box);
    }
}

var blogScreen = {
    init, show, hide
};

export default blogScreen;
